import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface RichTextPropertyEditorProps {
  value?: string;
  onChange: (value: string) => void;
}

const toolbarOptions = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["clean"],
];

const RichTextPropertyEditor: React.FC<RichTextPropertyEditorProps> = ({
  value = "",
  onChange,
}) => {
  return (
    <div className="isn-rich-text-property-editor">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={{ toolbar: toolbarOptions }}
      />
    </div>
  );
};

export default RichTextPropertyEditor;
